import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserAuth } from '~/components/Auth';
import { fetchUserSyncEnabledInCallAI } from './api';
import { CALLAI_PERMISSION, CALL_AI_REQUIRED_ROLES } from './constants';
import { getApplicationAccessLink, APPLICATIONS } from '~/components/ApplicationUrls';

import CallAI from '../Renderer';
import { hasPermission } from './utils';

export const CallAIWrapper = () => {
  const auth = useUserAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [renderCallAI, updateCallAIRenderState] = useState(false);
  const [callAIBaseUrl, updateCallAIBaseUrl] = useState('');
  const [toUseMTAuth, updateToUseMTAuth] = useState(false);

  const {
    company: {
      companySettings: { callAIEnabledInLS = false },
      id: cname,
    },
    sessionId,
    learnerRoles = [],
    permissions = {},
  } = auth;

  useEffect(() => {
    if (callAIEnabledInLS) {
      fetchUserSyncEnabledInCallAI({ sessionId, cname }).then(
        // eslint-disable-next-line complexity, max-statements
        ({
          isUserSyncEnabledInCallAI,
          toUseMTAuth,
          callAIBaseUrl,
          useCallAIMF,
          isSharingWorkflowEnabled,
        }) => {
          if (useCallAIMF) {
            let callAIRoute = getApplicationAccessLink(APPLICATIONS.CALL_AI);
            const parentUrlSubroute = location.pathname?.split(
              getApplicationAccessLink(APPLICATIONS.LEARNER_CALL_AI)
            )[1];
            if (parentUrlSubroute) {
              callAIRoute = callAIRoute + parentUrlSubroute;
            }
            if (location.search) {
              callAIRoute += `${decodeURIComponent(location.search.replace('?search=', '?'))}`;
            }
            navigate(callAIRoute, {
              replace: true,
            });
          }
          updateCallAIBaseUrl(callAIBaseUrl);
          updateToUseMTAuth(toUseMTAuth);
          const userHasRoles = !!CALL_AI_REQUIRED_ROLES.find((value: string) =>
            learnerRoles.includes(value)
          );
          const userHasPermissions = hasPermission(permissions, CALLAI_PERMISSION);
          const allow = isSharingWorkflowEnabled ? userHasPermissions : userHasRoles;
          /**
            callAIEnabledInLS   isUserSyncEnabledInCallAI       allow            isCallAIEnabled
            0                   0                               0                       0
            0                   0                               1                       0
            0                   1                               0                       0
            0                   1                               1                       0
            1                   0                               0                       1
            1                   0                               1                       1
            1                   1                               0                       0
            1                   1                               1                       1

            AB'C' + AB'C + ABC
            A(B'C'+B'C+BC)
            A(B'+BC)
            callAIEnabledInLS && (!isUserSyncEnabledInCallAI || (isUserSyncEnabledInCallAI && allow))
          */
          const isCallAIEnabled =
            callAIEnabledInLS &&
            (!isUserSyncEnabledInCallAI || (isUserSyncEnabledInCallAI && allow));
          updateCallAIRenderState(isCallAIEnabled);
          if (!isCallAIEnabled) {
            navigate(getApplicationAccessLink(APPLICATIONS.LEARNER_READINESS_DASHBOARD), {
              replace: true,
            });
          }
        }
      );
    } else {
      navigate(getApplicationAccessLink(APPLICATIONS.LEARNER_READINESS_DASHBOARD), {
        replace: true,
      });
    }
  }, [callAIEnabledInLS, cname, learnerRoles, navigate, sessionId]);

  return renderCallAI ? <CallAI toUseMTAuth={toUseMTAuth} callAIBaseUrl={callAIBaseUrl} /> : null;
};

export default CallAIWrapper;
